import React, { useEffect, useRef, useState } from "react";
import GoogleMap from "google-maps-react-markers";
import { config } from "../../../../../../api/config";
import { DEFAULT_CENTER, DEFAULT_ZOOM_LEVEL, MAP_STYLE } from "../../const";
import { Box, BoxProps } from "@material-ui/core";
import { PreviewMapConnectorProps } from "./container";
import { RouteComponentProps } from "react-router-dom";
import { ActionButton } from "halifax";
import styles from "./styles.module.scss";

export interface IPreviewMap
  extends PreviewMapConnectorProps,
    RouteComponentProps,
    BoxProps {
  onClick?: () => void;
}

export const PreviewMap = ({
  searchCentroids,
  searchBoundingBox,
  onClick,
  ...props
}: IPreviewMap) => {
  const mapRef = useRef<any>(null);
  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);

  useEffect(() => {
    if (googleMapsLoaded && mapRef.current) {
      if (searchBoundingBox) {
        mapRef.current.fitBounds(
          new google.maps.LatLngBounds(
            {
              lat: searchBoundingBox.southWest.lat,
              lng: searchBoundingBox.southWest.lon,
            },
            {
              lat: searchBoundingBox.northEast.lat,
              lng: searchBoundingBox.northEast.lon,
            }
          )
        );
      }

      if (searchCentroids) {
        mapRef.current.panTo({
          lat: searchCentroids?.lat || 0,
          lng: searchCentroids?.lon || 0,
        });
      }
    }
  }, [googleMapsLoaded, searchCentroids, searchBoundingBox]);

  const onGoogleApiLoaded = ({ map }: any) => {
    mapRef.current = map;
    setGoogleMapsLoaded(true);
  };

  return (
    <Box {...props} onClick={onClick} position="relative">
      <GoogleMap
        apiKey={config.googleMapsApiKey}
        options={{
          clickableIcons: false,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          styles: MAP_STYLE,
          gestureHandling: "none",
          cameraControl: false,
        }}
        loadScriptExternally
        status="ready"
        errorContent={null}
        defaultCenter={DEFAULT_CENTER}
        defaultZoom={DEFAULT_ZOOM_LEVEL}
        onGoogleApiLoaded={onGoogleApiLoaded}
      >
        <ActionButton
          className={styles.viewButton}
          onClick={() => onClick && onClick()}
          message="View map"
        />
      </GoogleMap>
    </Box>
  );
};
